/**
 * IndustryService
 * Service for Industry entity operations
 * Route: api/industries
 */
import { CrudService } from '../base/CrudService';
/**
 * IndustryService
 * Handles industry classification CRUD operations
 */
export class IndustryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? IndustryService.DEFAULT_SERVICE_PATH,
            basePath: IndustryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== VIEW METHODS ====================
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    getAllViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    async getViewById(id) {
        const response = await this.getViewByIdRaw(id);
        return response.data ?? null;
    }
    getViewByIdRaw(id) {
        const url = this.buildUrl(`views/${id}`);
        return this.http.get(url);
    }
}
IndustryService.DEFAULT_SERVICE_PATH = 'suppliers';
IndustryService.BASE_PATH = 'api/industries';
//# sourceMappingURL=IndustryService.js.map